<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title">中标结果通知书</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="标段名称:">
                    <el-input v-model="searchForm.bidSectionName" placeholder="请输入标段名称" style="width: 200px;">
                    </el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="80" align="center">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 }}
                    </template>
                </el-table-column>

                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="awardNoticeCode" label="通知书编号" show-overflow-tooltip />
                <el-table-column prop="bidders" label="中标人" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.bidders && scope.row.bidders.length > 0">
                            {{scope.row.bidders.map(b => b.winBidderName).join('、')}}
                        </span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="noticeType" label="通知类型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.noticeType === 1">中标结果通知书</span>
                        <span v-else-if="scope.row.noticeType === 2">招标结果通知书</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="bidders" label="中标金额" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.bidders && scope.row.bidders.length > 0">
                            {{scope.row.bidders.map(b => b.bidAmount).join('、')}}
                        </span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 0">暂存</span>
                        <span v-else-if="scope.row.status === 1">提交</span>
                        <span v-else-if="scope.row.status === 9">发布</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)" class="action-btn">
                            详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

        <!-- 添加中标结果通知书弹窗 -->
        <el-dialog :title="isViewMode ? '查看中标结果通知书' : '添加中标结果通知书'" :visible.sync="addDialogVisible" width="1000px"
            :before-close="handleCloseAddDialog" :append-to-body="true" class="add-notification-dialog">

            <el-form :model="addForm" :rules="addRules" ref="addForm" label-width="120px" class="add-form">
                <el-row :gutter="20">
                    <!-- 左列 -->
                    <el-col :span="12">
                        <!-- 选择标段 -->
                        <el-form-item label="选择标段:" prop="bidSection" required>
                            <el-select v-model="addForm.bidSection" placeholder="请选择标段" style="width: 100%;"
                                @change="handleSectionChange" :disabled="isViewMode">
                                <el-option v-for="item in sectionOptions" :key="item.sectionId"
                                    :label="item.bidSectionName" :value="item.bidSectionCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- 通知书类型 -->
                        <el-form-item label="通知书类型:" prop="noticeType" required>
                            <el-select v-model="addForm.noticeType" placeholder="请选择通知书类型" style="width: 100%;" :disabled="isViewMode">
                                <el-option label="中标结果通知书" :value="1"></el-option>
                                <el-option label="招标结果通知书" :value="2"></el-option>
                            </el-select>
                        </el-form-item>

                        <!-- 价款形式 -->
                        <el-form-item label="价款形式:" prop="priceFormCode" required>
                            <el-select v-model="addForm.priceFormCode" placeholder="请选择价款形式" style="width: 100%;" :disabled="isViewMode">
                                <el-option label="总价" :value="1"></el-option>
                                <el-option label="单价" :value="2"></el-option>
                                <el-option label="费率" :value="3"></el-option>
                                <el-option label="其他" :value="9"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- 右列 -->
                    <el-col :span="12">
                        <!-- 通知书编号 -->
                        <el-form-item label="通知书编号:" prop="awardNoticeCode">
                            <el-input v-model="addForm.awardNoticeCode" placeholder="请输入通知书编号" style="width: 100%;" :disabled="isViewMode">
                            </el-input>
                        </el-form-item>

                        <!-- 中标人 -->
                        <el-form-item label="中标人:" prop="winningBidder" >
                            <el-select v-model="addForm.winningBidder" placeholder="请选择中标人/未中标人" style="width: 100%;"
                                :disabled="!addForm.bidSection || isViewMode" :loading="loadingBidders" multiple>
                                <el-option v-for="item in bidderOptions" :key="item.bidderCode" :label="item.bidderName"
                                    :value="item.bidderCode">
                                </el-option>
                            </el-select>
                            <div v-if="!addForm.bidSection && !isViewMode" class="warning-text">
                                注意:选择候选人之前必须先选择标段
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 中标人信息表格 -->
                <el-form-item label="中标人信息:" v-if="addForm.winningBidder && addForm.winningBidder.length > 0 &&!isViewMode">
                    <el-table :data="bidderTableData" border style="width: 100%">
                        <el-table-column prop="winBidderName" label="中标人" width="200" />
                        <el-table-column label="中标金额" width="150">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.bidAmount" placeholder="请输入金额" type="number" :disabled="isViewMode"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="单位" width="100">
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.priceUnit" placeholder="单位" :disabled="isViewMode">
                                    <el-option label="元" :value="0"></el-option>
                                    <el-option label="万元" :value="1"></el-option>
                                    <el-option label="%" :value="2"></el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column label="费率或其它类型结果" width="180">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.otherBidPrice" placeholder="请输入" :disabled="isViewMode"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form-item>

                <!-- 通知书内容 -->
                <el-form-item label="通知书内容:" prop="awardContent">
                    <el-input type="textarea" v-model="addForm.awardContent" :rows="5"
                        placeholder="请输入通知书内容" :disabled="isViewMode"></el-input>
                </el-form-item>

                <!-- 附件 -->
                <el-form-item label="附件:" prop="fileGuid">
                    <div class="upload-container" v-if="!isViewMode">
                        <el-button type="primary" @click="handleSelectFile">选择文件</el-button>
                        <input type="file" ref="fileInput" style="display: none" multiple @change="handleFileChange" />
                        <span class="upload-tip">支持上传多个文件</span>
                    </div>
                    <div v-if="fileList.length > 0" class="file-list">
                        <div v-for="(file, index) in fileList" :key="index" class="file-item">
                            <span class="file-name">{{ file.name }}</span>
                            <el-progress v-if="file.uploading" :percentage="file.progress"></el-progress>
                            <span v-if="file.uploaded" class="file-status success">已上传</span>
                            <a v-if="isViewMode && file.fileUrl" :href="file.fileUrl" target="_blank" class="file-download">下载</a>
                            <el-button v-if="!isViewMode" type="text" @click="removeFile(index)">删除</el-button>
                        </div>
                    </div>
                </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseAddDialog">{{ isViewMode ? '关闭' : '取消' }}</el-button>
                <el-button v-if="!isViewMode" type="primary" @click="handleSaveDraft" :loading="saving">暂存</el-button>
                <el-button v-if="!isViewMode" type="primary" @click="handleSaveAndSubmit" :loading="saving">保存并提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { doFileUpload } from '@/utils/fileUploadHelper'
import { getFileList } from '@/api/base/api'
import { awardNoticeAdd, awardNoticeBidSectionList, awardNoticeBidders, awardNoticeDelete, awardNoticeDetail, awardNoticeList } from '@/api/winBulletin/api'

export default {
    components: {
    },
    name: 'BidResultNotification',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            loading: false,
            saving: false,
            addDialogVisible: false,
            loadingBidders: false,
            searchForm: {
                bidSectionName: ''
            },
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 0
            },
            // 添加表单数据
            addForm: {
                bidSection: '',
                bidSectionName: '',
                noticeType: 1,
                awardNoticeCode: '',
                winningBidder: [],
                priceFormCode: 1,
                awardContent: '',
                fileGuid: ''
            },
            // 文件列表
            fileList: [],
            // 中标人表格数据
            bidderTableData: [],
            // 表单验证规则
            addRules: {
                bidSection: [
                    { required: true, message: '请选择标段', }
                ],
                noticeType: [
                    { required: true, message: '请选择通知书类型', }
                ],
                priceFormCode: [
                    { required: true, message: '请选择价款形式', }
                ],
                awardNoticeCode: [
                    { required: true, message: '请输入通知书编号', }
                ]
            },
            // 标段选项
            sectionOptions: [],
            // 投标人选项
            bidderOptions: [],
            // 查看模式标识
            isViewMode: false
        }
    },
    mounted() {
        this.loadData()
        this.getProjectInfo()
        this.initFileGuid()
    },
    methods: {
        // 初始化文件关联标识
        initFileGuid() {
            this.addForm.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
        },
        // 加载数据
        async loadData() {
            this.loading = true
            try {
                await this.fetchAwardNoticeList()
            } finally {
                this.loading = false
            }
        },
        // 列表
        async fetchAwardNoticeList() {
            try {
                const res = await awardNoticeList({
                    projectCode: this.projectCode,
                    bidSectionName: this.searchForm.bidSectionName,
                    pageNum: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize,
                })
                if (res.code == 200) {
                    this.tableData = res.data.records || []
                    this.pagination.total = res.data.total || 0
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('获取列表失败:', error)
                this.$message.error('获取列表失败')
            }
        },
     
        // 获取标段中标人信息
        async loadBidderList(bidSectionCode) {
            if (!bidSectionCode) return
            this.loadingBidders = true
            try {
                const res = await awardNoticeBidders({
                    bidSectionCode: bidSectionCode
                })
                if (res.code == 200) {
                    this.bidderOptions = res.data || []
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('获取中标人信息失败:', error)
                this.$message.error('获取中标人信息失败')
            } finally {
                this.loadingBidders = false
            }
        },
        // 标段选择变化
        handleSectionChange(value) {
            // 清空中标人选择
            this.addForm.winningBidder = []
            this.bidderOptions = []
            this.bidderTableData = []
            // 获取选中标段的名称
            const selectedSection = this.sectionOptions.find(item => item.bidSectionCode === value)
            if (selectedSection) {
                this.addForm.bidSectionName = selectedSection.bidSectionName
            }
            this.loadBidderList(value)
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },

     
        // 关闭添加弹窗
        handleCloseAddDialog() {
            this.addDialogVisible = false
            this.resetAddForm()
        },

        // 暂存
        handleSaveDraft() {
            this.submitForm(0)
        },
        // 保存并提交
        handleSaveAndSubmit() {
            this.$refs.addForm.validate((valid) => {
                if (valid) {
                    this.submitForm(1)
                } else {
                    this.$message.error('请完善必填信息')
                }
            })
        },
        // 提交表单
        async submitForm(status) {
            // 构建中标人信息数组
            const bidders = this.addForm.winningBidder.map(bidderCode => {
                const bidder = this.bidderOptions.find(item => item.bidderCode === bidderCode)
                const tableData = this.bidderTableData.find(item => item.winBidderGuid === bidderCode)
                return {
                    winBidderGuid: bidderCode,
                    winBidderName: bidder ? bidder.bidderName : '',
                    winBidderUserId: bidder ? bidder.bidderOrgCode : '',
                    bidAmount: tableData ? tableData.bidAmount : '',
                    priceUnit: tableData ? tableData.priceUnit : 0,
                    priceFormCode: this.addForm.priceFormCode,
                    otherBidPrice: tableData ? tableData.otherBidPrice : ''
                }
            })
            const params = {
                projectCode: this.projectCode,
                bidSectionCode: this.addForm.bidSection,
                bidSectionName: this.addForm.bidSectionName,
                awardNoticeCode: this.addForm.awardNoticeCode,
                noticeType: this.addForm.noticeType,
                awardContent: this.addForm.awardContent,
                fileGuid: this.addForm.fileGuid,
                bidders: bidders,
                status: status // 0：暂存、1：提交
            }
            this.saving = true
            try {
                const res = await awardNoticeAdd(params)
                if (res.code == 200) {
                    this.$message.success(status === 0 ? '暂存成功' : '保存并提交成功')
                    this.addDialogVisible = false
                    this.resetAddForm()
                    this.loadData()
                } else {
                    this.$message.error(res.msg)
                }
            } catch (error) {
                console.error('提交失败:', error)
                this.$message.error('提交失败')
            } finally {
                this.saving = false
            }
        },
        // 重置添加表单
        resetAddForm() {
            this.addForm = {
                bidSection: '',
                bidSectionName: '',
                noticeType: 1,
                awardNoticeCode: '',
                winningBidder: [],
                priceFormCode: 1,
                awardContent: '',
                fileGuid: ''
            }
            this.fileList = []
            this.bidderTableData = []
            this.bidderOptions = []
            this.isViewMode = false // 重置查看模式
            if (this.$refs.addForm) {
                this.$refs.addForm.resetFields()
            }
            // 重新初始化 fileGuid
            this.initFileGuid()
        },

        // 选择文件
        handleSelectFile() {
            this.$refs.fileInput.click()
        },

        // 文件选择变化
        async handleFileChange(event) {
            const files = Array.from(event.target.files)
            if (files.length === 0) return

            for (const file of files) {
                const fileItem = {
                    name: file.name,
                    size: file.size,
                    uploading: true,
                    uploaded: false,
                    progress: 0,
                    fileGuid: '',
                    uploadFileId: '',
                    filePath: ''
                }
                this.fileList.push(fileItem)

                try {
                    const result = await doFileUpload(file, {
                        fileBindId: this.addForm.fileGuid,
                        onProgress: (percentage) => {
                            fileItem.progress = percentage
                        },
                        onSuccess: (res) => {
                            fileItem.uploading = false
                            fileItem.uploaded = true
                            fileItem.fileGuid = res.fileGuid
                            fileItem.uploadFileId = res.uploadFileId
                            fileItem.filePath = res.filePath
                        },
                        onError: (error) => {
                            fileItem.uploading = false
                            this.$message.error(`文件 ${file.name} 上传失败: ${error.message}`)
                        }
                    })
                } catch (error) {
                    fileItem.uploading = false
                    this.$message.error(`文件 ${file.name} 上传失败`)
                }
            }

            // 清空input
            event.target.value = ''
        },

        // 删除文件
        removeFile(index) {
            this.$confirm('确定要删除该文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.fileList.splice(index, 1)
                this.$message.success('删除成功')
            }).catch(() => { })
        },

        // 搜索
        handleSearch() {
            this.pagination.currentPage = 1
            this.loadData()
        },

        // 查看详情
        handleView(row) {
            this.awardNoticeDetail(row)
        },
        // 详情接口
        awardNoticeDetail(row) {
            awardNoticeDetail({
                awardNoticeCode: row.awardNoticeCode
            }).then(res => {
                if (res.code == 200) {
                    const data = res.data
                    // 填充表单数据
                    this.addForm = {
                        bidSection: data.bidSectionCode,
                        bidSectionName: data.bidSectionName,
                        noticeType: data.noticeType,
                        awardNoticeCode: data.awardNoticeCode,
                        winningBidder: data.bidders ? data.bidders.map(b => b.winBidderGuid) : [],
                        priceFormCode: 1, // 默认值
                        awardContent: data.awardContent,
                        fileGuid: data.fileGuid
                    }
                    
                    // 填充中标人表格数据
                    this.bidderTableData = data.bidders ? data.bidders.map(bidder => ({
                        winBidderGuid: bidder.winBidderGuid,
                        winBidderName: bidder.winBidderName || '',
                        bidAmount: bidder.bidAmount || '',
                        priceUnit: bidder.priceUnit || 0,
                        otherBidPrice: bidder.otherBidPrice || ''
                    })) : []
                    
                    this.isViewMode = true 
                    this.addDialogVisible = true
                    this.getFileList(data.fileGuid)
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 获取文件列表
        async getFileList(fileGuid) {
            try {
                const res = await getFileList(fileGuid)
                if (res.code === 200 && res.data) {
                    this.fileList = res.data.map(file => ({
                        name: file.fileName,
                        size: file.fileSize,
                        uploading: false,
                        uploaded: true,
                        progress: 100,
                        fileGuid: file.fileId,
                        uploadFileId: file.fileId,
                        filePath: file.fileUrl,
                        fileUrl: file.fileUrl,
                        fileExtension: file.fileExtension
                    }))
                } else {
                    this.$message.error(res.msg || '获取文件列表失败')
                }
            } catch (error) {
                console.error('获取文件下载列表失败:', error)
                this.$message.error('获取文件下载列表失败，请重试')
            }
        },


  

        // 分页相关方法
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
    },
    watch: {
        // 监听中标人选择变化，更新表格数据
        'addForm.winningBidder': {
            handler(newVal) {
                if (newVal && newVal.length > 0) {
                    // 构建表格数据
                    this.bidderTableData = newVal.map(bidderCode => {
                        const bidder = this.bidderOptions.find(item => item.bidderCode === bidderCode)
                        const existingData = this.bidderTableData.find(item => item.winBidderGuid === bidderCode)

                        return {
                            winBidderGuid: bidderCode,
                            winBidderName: bidder ? bidder.bidderName : '',
                            bidAmount: existingData ? existingData.bidAmount : '',
                            priceUnit: existingData ? existingData.priceUnit : 0,
                            otherBidPrice: existingData ? existingData.otherBidPrice : ''
                        }
                    })
                } else {
                    this.bidderTableData = []
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.search-section {
    margin-bottom: 20px;
    padding: 16px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: @shadow-sm;
}

.content-container,
.table-section {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
}

.data-table {
    border-radius: 4px;
    overflow: hidden;

    /deep/ th {
        background: @gray-50 !important;
        color: @gray-700 !important;
        font-weight: 600;
        border-color: @gray-200 !important;
    }

    /deep/ td {
        color: @gray-600;
        border-color: @gray-200 !important;
    }
}

.pagination-section {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
}

.action-btn {
    color: @gray-600;

    &:hover {
        color: @primary-color;
    }
}

/deep/ .el-dialog {
    border-radius: 8px;
}

/deep/ .el-dialog__header {
    background: @gray-50;
    border-bottom: 1px solid @gray-200;
}

/deep/ .el-dialog__title {
    color: @gray-700;
    font-weight: 600;
}

@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .search-section,
    .content-container,
    .table-section {
        padding: 16px;
    }
}

.page-title {
    color: #333;
    margin: 0;
    font-weight: bold;
}

.search-section {
    padding: 0px 20px;
    margin-top: 20px;

    .search-form {
        .el-form-item {
            margin-bottom: 0;
        }
    }
}

.table-section {
    padding: 10px;
}

.data-table {
    .action-btn {
        color: #409EFF;
    }
}

.pagination-section {
    display: flex;
    justify-content: flex-end;
}

// 添加中标结果通知书弹窗样式
.add-notification-dialog {
    .add-form {
        .el-form-item {
            margin-bottom: 20px;

            .el-form-item__label {
                color: #333;
                font-weight: 500;
            }

            .el-select,
            .el-input {
                width: 100%;
            }

            .price-input-group {
                display: flex;
                align-items: center;
            }

            .warning-text {
                color: #f56c6c;
                font-size: 12px;
                margin-top: 5px;
            }

            .el-radio-group {
                .el-radio {
                    margin-right: 20px;
                }
            }

            .upload-container {
                display: flex;
                align-items: center;
                gap: 10px;

                .upload-tip {
                    color: #909399;
                    font-size: 12px;
                }
            }

            .file-list {
                margin-top: 15px;

                .file-item {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    padding: 10px;
                    background-color: #f5f7fa;
                    border-radius: 4px;
                    margin-bottom: 10px;

                    .file-name {
                        flex: 1;
                        font-size: 14px;
                        color: #606266;
                    }

                    .file-status {
                        font-size: 12px;

                        &.success {
                            color: #67c23a;
                        }
                    }

                    .el-progress {
                        flex: 1;
                    }

                    .file-download {
                        color: #409EFF;
                        text-decoration: none;
                        font-size: 12px;
                        
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }
            }
        }
    }

    .dialog-footer {
        text-align: center;
        padding-top: 20px;
        border-top: 1px solid #eee;
    }
}
</style>
